import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IProtocolo } from '../models/protocolo.model';

@Injectable()
export class ProtocoloService extends EntityService<IProtocolo> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'protocolo'
    });
  }
}
